import { render, staticRenderFns } from "./specialistInfoView.vue?vue&type=template&id=c58c138c&"
import script from "./specialistInfoView.vue?vue&type=script&lang=js&"
export * from "./specialistInfoView.vue?vue&type=script&lang=js&"
import style0 from "./specialistInfoView.vue?vue&type=style&index=0&id=c58c138c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports